import { ROLE_ADMIN } from '@/enum/roles'
import routeType from '@/router/routeType'

const meta = {
    requiresAuth: true,
    roles: [ROLE_ADMIN],
    layout: 'ordit-authenticated-layout',
}

const passthroughRender = {
    render: (c) => c('router-view'),
}

export default [
    {
        path: '/translations',
        component: passthroughRender,
        meta,
        children: [
            {
                path: '',
                name: routeType.TRANSLATION_LIST,
                component: () =>
                    import(
                        /* webpackChunkName: "translations-list" */ '@/pages/translations/List.vue'
                    ),
                meta,
            },
        ],
    },
]
